/*eslint-disable */

export default {
  getApplicationStaticConfig(state) {
    return state.applicationStaticConfig
  },
  getActiveMicroApp(state) {
    return state.activeMicroApp
  }
}
